import { CartesiaModelId, Gender, InWorldModelId, ModelId, TextToSpeechProviderName, VoiceFailureReason, VoiceStatus, VoiceType, } from "@next-platform/packages-ts-types";
export { CartesiaModelId, Gender, InWorldModelId, ModelId, TextToSpeechProviderName, };
var VOICE_ACTIONS;
(function (VOICE_ACTIONS) {
    VOICE_ACTIONS["GET_ALL_VOICES"] = "voices/get";
    VOICE_ACTIONS["SAVE_CONVERSATION_VOICE_ID"] = "voices/saveConversationVoiceId";
    VOICE_ACTIONS["RATE_VOICE_QUALITY"] = "voices/rateVoiceQuality";
    VOICE_ACTIONS["CREATE_CONVERSATION_SET_VOICE_ID"] = "voices/createConversationSetVoiceId";
    VOICE_ACTIONS["GET_VOICE_LANGUAGES"] = "voices/languages";
})(VOICE_ACTIONS || (VOICE_ACTIONS = {}));
var VOICE_ACTION_TYPES;
(function (VOICE_ACTION_TYPES) {
    VOICE_ACTION_TYPES["GET_ALL_VOICES"] = "GET_ALL_VOICES";
    VOICE_ACTION_TYPES["RATE_VOICE_QUALITY"] = "RATE_VOICE_QUALITY";
    VOICE_ACTION_TYPES["SET_CONVERSATION_VOICE_ID"] = "SET_CONVERSATION_VOICE_ID";
})(VOICE_ACTION_TYPES || (VOICE_ACTION_TYPES = {}));
var SampleRate;
(function (SampleRate) {
    SampleRate[SampleRate["SAMPLE_RATE_48000"] = 48000] = "SAMPLE_RATE_48000";
    SampleRate[SampleRate["SAMPLE_RATE_44100"] = 44100] = "SAMPLE_RATE_44100";
    SampleRate[SampleRate["SAMPLE_RATE_16000"] = 16000] = "SAMPLE_RATE_16000";
    SampleRate[SampleRate["SAMPLE_RATE_8000"] = 8000] = "SAMPLE_RATE_8000";
})(SampleRate || (SampleRate = {}));
export { SampleRate, VOICE_ACTION_TYPES, VOICE_ACTIONS, VoiceFailureReason, VoiceStatus, VoiceType, };
